import React, { useState, useRef } from 'react'

import { InputField, FlashMessage, GlobalLoader, ModalAlert, Modal, CheckboxInput, DropDownMenu, RadioInput } from '@reactiveonline/reactive_admin_shared-packages'
import Activities from './version_1/Activities'

const radioOptions = [
  { key: 'default',     title: ReactiveCore.translations.invoicing_onboarding.statement_rejection_options.default     },
  { key: 'wrong_dates', title: ReactiveCore.translations.invoicing_onboarding.statement_rejection_options.wrong_dates },
]

export default function Version1({
  invoicingOnboarding, canManageInvoicingOnboarding, uploadContractPath, acceptSignedContractPath, completeAuthorizationPath, downloadFilePath, saveApiIntegrationKeysPath,
  cancelOnboardingPath, rejectContractPath, rejectAuthorizationPath, rejectStatementPath, rejectInfoPath, sendInvoicingSoftwareEmailPath, apiIntegrationSettings,
  notifyCustomerForApiKeysPath, skipInvoicingOnboardingPath, canSkipInvoicingOnboarding, generateContractPath, updateSettingsPath, unsignedContractDate, activities, stores, contractNo
}) {
  let { currentStep, businessType } = invoicingOnboarding || {}
  const [files, setFiles] = useState(invoicingOnboarding ? invoicingOnboarding.files : [])
  const idCopiesFiles = files.filter(file => ['id_copy', 'legal_representative_id_copy'].includes(getFileUsage(file)))
  const unsignedContractFile = files.find(file => getFileUsage(file) === 'unsigned_contract')
  let onboardingSettings = invoicingOnboarding ? invoicingOnboarding.settings : []
  const informedProviderSetting = onboardingSettings.find(setting => setting.key === 'provider_notification')
  const informedCustomerSetting = onboardingSettings.find(setting => setting.key === 'customer_notification')
  const rejectedInfoReasonSetting = onboardingSettings.find(setting => setting.key === 'rejected_info_reason')
  onboardingSettings = onboardingSettings.filter(setting => !['provider_notification', 'customer_notification', 'rejected_info_reason'].includes(setting.key))
  const [settings, setSettings] = useState(onboardingSettings)
  const [rejectedSettings, setRejectedSettings] = useState([])
  const [rejectedFiles, setRejectedFiles] = useState([])

  const [onboardingStep, setOnboardingStep] = useState(currentStep)
  const [loading, setLoading] = useState(false)
  const [showCancelAlert, setShowCancelAlert] = useState(false)
  const [rejectionExplanation, setRejectionExplanation] = useState('')
  const [rejectedContractNumber, setRejectedContractNumber] = useState(contractNo)
  const [showRejectionModal, setShowRejectionModal] = useState(false)
  const [showStatementRejectionModal, setShowStatementRejectionModal] = useState(false)
  const [currentRadioOption, setCurrentRadioOption] = useState('default')
  const [showNotifyCustomerAlert, setShowNotifyCustomerAlert] = useState(false)
  const [showEmailToProviderAlert, setShowEmailToProviderAlert] = useState(false)
  const [showSkipOnboardingProcessAlert, setShowSkipOnboardingProcessAlert] = useState(false)

  const existedIssueValiditySetting = settings.find(setting => setting.key === "statement_issue_validity_date")
  const existedContractNumberSetting = settings.find(setting => setting.key === "contract_number")
  const existedContractConclusionSetting = settings.find(setting => setting.key === "statement_contract_inclusion_date")

  const initialStatementDateState = {
    issueValidity: existedIssueValiditySetting ? existedIssueValiditySetting.value : (unsignedContractDate || ''),
    contractConclusion: existedContractConclusionSetting ? existedContractConclusionSetting.value : (unsignedContractDate || '')
  }

  const [statementDates, setStatementDates] = useState(initialStatementDateState)
  const [statementRejectionDates, setStatementRejectionDates] = useState(initialStatementDateState)
  const [informedProvider, setInformedProvider] = useState(informedProviderSetting && informedProviderSetting.value === currentStep)
  const [informedCustomer, setInformedCustomer] = useState(informedCustomerSetting && informedCustomerSetting.value === 'true')
  const [rejectedInfoReason, setRejectedInfoReason] = useState(rejectedInfoReasonSetting && rejectedInfoReasonSetting.value)
  const [contractGenerationStarted, setContractGenerationStarted] = useState(false)
  const [contractNumber, setContractNumber] = useState(existedContractNumberSetting ? existedContractNumberSetting.value : contractNo)
  const initialApiKey = apiIntegrationSettings && apiIntegrationSettings['api_key']
  const initialSeries = apiIntegrationSettings && apiIntegrationSettings['series']
  const initialTestMode = apiIntegrationSettings && apiIntegrationSettings['test_mode']
  const [apiKey, setApiKey] = useState(initialApiKey || '')
  const [series, setSeries] = useState(initialSeries || '')
  const [testMode, setTestMode] = useState((initialTestMode && initialTestMode !== '0') || false)
  const flashMessageRef = useRef(null)

  const contractFiles = ["business_start_certification", "change_business_certification", "company_establishment_certification", "change_company_certification"]
  const initialSignedContractFiles = files.filter(file => getFileUsage(file) === 'signed_contract')
  const [signedContractFiles, setSignedContractFiles] = useState(initialSignedContractFiles)

  const initialStatement = files.find(file => getFileUsage(file) === 'statement')
  const [statement, setStatement] = useState(initialStatement)

  const availableAuthorization = ['authorization', 'completed_authorization'].includes(currentStep)
  const availableStatement = ['statement', 'completed_statement', 'completed'].includes(currentStep) || (currentStep === 'completed_authorization' && informedProviderSetting.value === currentStep)
  const [showAuthorization, setShowAuthorization] = useState(availableAuthorization || availableStatement)
  const [showStatement, setShowStatement] = useState(availableStatement)

  function getFileUsage(file){
    return(file.file_name.split('/')[2])
  }

  function downloadFile(_event, fileUsage, fileName){
    setLoading(true)

    if (fileUsage !== 'unsigned_contract') {
      Rails.ajax({
        type: 'POST',
        url: `${downloadFilePath}?file_usage=${fileUsage}${fileName ? `&file_name=${fileName}` : ''}`,
        dataType: 'json',
        success: res => {
          window.open(res.sourceUrl, '_blank')
          setLoading(false)
        }
      })
    } else {
      const form = document.createElement('form')
      const csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content")
      const hiddenField = document.createElement('input')

      form.method = 'post'
      form.action = `${downloadFilePath}?file_usage=${fileUsage}${fileName ? `&file_name=${fileName}` : ''}`
      hiddenField.type = 'hidden'
      hiddenField.name = "authenticity_token"
      hiddenField.value = csrf
      form.appendChild(hiddenField)
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
      setLoading(false)
    }
  }

  function updateSetting(key, value){
    let currentSettings = [...settings]
    let updatedSetting = currentSettings.find(setting => setting.key === key)
    updatedSetting.value = value
    setSettings([...currentSettings.filter(setting => setting.key !== key), updatedSetting].sort((a,b) => a.id - b.id))
  }

  function updateRejectedSettings(key, checked){
    let currentRejectedSettings = [...rejectedSettings]
    if (checked){
      setRejectedSettings([...currentRejectedSettings, key])
    } else {
      setRejectedSettings(currentRejectedSettings.filter(settingKey => settingKey !== key))
    }
  }

  function updateRejectedFiles(fileId, checked){
    let currentRejectedFiles = [...rejectedFiles]
    if (checked){
      setRejectedFiles([...currentRejectedFiles, fileId])
    } else {
      setRejectedFiles(currentRejectedFiles.filter(id => id !== fileId))
    }
  }

  function handleSubmitContract(){
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: uploadContractPath,
      dataType: 'json',
      success: res => {
        setLoading(false)
        setInformedProvider(false)
        setRejectedInfoReason(null)
        setOnboardingStep('signing_contract')
        flashMessageRef.current.show(res.message, 'success')
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.errors, 'error')
      }
    })
  }

  function handleUpdateSettings(){
    setLoading(true)
    let fd = new FormData()
    settings.forEach((setting, index) => {
      fd.append(`invoicing_onboarding[settings_attributes][${index}][key]`, setting.key)
      fd.append(`invoicing_onboarding[settings_attributes][${index}][value]`, setting.value.trim())
      fd.append(`invoicing_onboarding[settings_attributes][${index}][id]`, setting.id)
    })

    Rails.ajax({
      type: 'POST',
      url: updateSettingsPath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message, 'success')
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message, 'error')
      }
    })

  }

  function handleAcceptContract(){
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: acceptSignedContractPath,
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message, 'success')
        setInformedProvider(false)
        setOnboardingStep('authorization')
        setShowAuthorization(true)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.errors, 'error')
      }
    })
  }

  function handleCompleteAuthorization(){
    if (!checkStatementDate(statementDates.issueValidity) || !checkStatementDate(statementDates.contractConclusion)){
      flashMessageRef.current.show(ReactiveCore.translations.invoicing_onboarding.invald_dates, 'error')
      return
    }

    setLoading(true)
    let fd = new FormData()
    fd.append('invoicing_onboarding[current_step]', 'statement')

    fd.append('invoicing_onboarding[settings_attributes][0][key]', 'statement_issue_validity_date')
    fd.append('invoicing_onboarding[settings_attributes][0][value]', statementDates.issueValidity.trim())
    if (existedIssueValiditySetting){
      fd.append('invoicing_onboarding[settings_attributes][0][id]', existedIssueValiditySetting.id)
    }

    fd.append('invoicing_onboarding[settings_attributes][1][key]', 'statement_contract_inclusion_date')
    fd.append('invoicing_onboarding[settings_attributes][1][value]', statementDates.contractConclusion.trim())
    if (existedContractConclusionSetting){
      fd.append('invoicing_onboarding[settings_attributes][1][id]', existedContractConclusionSetting.id)
    }

    fd.append('invoicing_onboarding[settings_attributes][2][key]', 'contract_number')
    fd.append('invoicing_onboarding[settings_attributes][2][value]', contractNumber.trim())
    if (existedContractNumberSetting){
      fd.append('invoicing_onboarding[settings_attributes][2][id]', existedContractNumberSetting.id)
    }

    Rails.ajax({
      type: 'POST',
      url: completeAuthorizationPath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message, 'success')
        setInformedProvider(false)
        setOnboardingStep('statement')
        setShowStatement(true)
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.errors, 'error')
      }
    })
  }

  function handleSaveApiIntegrationKeys(){
    setLoading(true)
    let fd = new FormData()
    fd.append('settings', JSON.stringify({ api_key: apiKey.replace(/ /g, ''), series: series.replace(/ /g, ''), test_mode: testMode }))

    Rails.ajax({
      type: 'POST',
      url: saveApiIntegrationKeysPath,
      dataType: 'json',
      data: fd,
      success: res => {
        setLoading(false)
        flashMessageRef.current.show(res.message, 'success')
        setOnboardingStep('completed')
      },
      error: res => {
        setLoading(false)
        flashMessageRef.current.show(res.errors, 'error')
      }
    })
  }

  function handleCancelOnboarding(){
    setLoading(true)
    setShowCancelAlert(false)

    Rails.ajax({
      type: 'POST',
      url: cancelOnboardingPath,
      success: res => {
        setOnboardingStep('cancelled')
        flashMessageRef.current.show(res.message, 'success')
      },
      complete: res => {
        setLoading(false)
      }
    })
  }

  function handleSkipOnboardingProcess(){
    setLoading(true)
    setShowSkipOnboardingProcessAlert(false)

    Rails.ajax({
      type: 'POST',
      url: skipInvoicingOnboardingPath,
      success: res => {
        setOnboardingStep('completed')
        setShowStatement(true)
        setShowAuthorization(true)

        flashMessageRef.current.show(res.message, 'success')
      },
      complete: res => {
        setLoading(false)
      }
    })
  }

  function handleSendMailToInvoicingSoftware(){
    setLoading(true)
    setShowEmailToProviderAlert(false)

    Rails.ajax({
      type: 'POST',
      dataType: 'json',
      url: sendInvoicingSoftwareEmailPath,
      success: res => {
        setInformedProvider(true)
        if (currentStep === 'completed_authorization'){
          setShowStatement(true)
        }
        setLoading(false)
        flashMessageRef.current.show(res.message, 'success')
      }
    })
  }

  function handleGenerateContract() {
    setContractGenerationStarted(true)
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      dataType: 'json',
      url: generateContractPath,
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setTimeout( ()=> {
          setLoading(false)
          window.location.reload()
        }, 3000)
      }
    })
  }

  function checkStatementDate(date){
    const pattern = /^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-](18|19|20)\d{2}$/g

    return pattern.test(date.trim())
  }

  function handleRejectStep(){
    let url, nextStep
    let fd = new FormData()
    if (currentStep === 'receiving_info'){
      url = rejectInfoPath
      fd.append('rejected_settings', JSON.stringify(rejectedSettings))
      fd.append('rejected_files', JSON.stringify(rejectedFiles))
    } else if (currentStep === "signed_contract"){
      url = rejectContractPath
      nextStep = 'signing_contract'
    } else if (currentStep === 'completed_authorization'){
      url = rejectAuthorizationPath
      nextStep = 'authorization'
    } else {
      url = rejectStatementPath
      nextStep = 'statement'
    }

    setShowRejectionModal(false)
    setLoading(true)

    if (currentRadioOption === 'default') {
      fd.append('rejection_explanation', rejectionExplanation)
    } else {
      fd.append('contract_conclusion', statementRejectionDates.contractConclusion)
      fd.append('issue_validity', statementRejectionDates.issueValidity)
      fd.append('contract_no', rejectedContractNumber)
    }

    Rails.ajax({
      type: 'POST',
      dataType: 'json',
      data: fd,
      url: url,
      success: res => {
        setLoading(false)
        setRejectionExplanation('')

        if (currentStep === 'signed_contract'){
          setSignedContractFiles([])
        } else if (currentStep === 'completed_statement'){
          setStatement(null)
        }

        setInformedProvider(false)
        if (currentStep === 'receiving_info'){
          setRejectedInfoReason(res.invoicingOnboarding.settings.find(setting => setting.key === 'rejected_info_reason').value)
          setSettings(res.invoicingOnboarding.settings.filter(setting => !['provider_notification', 'customer_notification', 'rejected_info_reason'].includes(setting.key)))
          setFiles(res.invoicingOnboarding.files)
          setRejectedSettings([])
          setRejectedFiles([])
        } else {
          setOnboardingStep(nextStep)
        }
        setShowRejectionModal(false)
        handleCloseStatementRejectionModal()
        flashMessageRef.current.show(res.message, 'success')
      }
    })
  }

  function handleNotifyCustomerForApiKeys(){
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      dataType: 'json',
      url: notifyCustomerForApiKeysPath,
      success: res => {
        setShowNotifyCustomerAlert(false)
        setLoading(false)
        setInformedCustomer(true)
        flashMessageRef.current.show(res.message, 'success')
      }
    })
  }

  const infoDropdownActions = [
    { icon: 'fa-ban', action: () => setShowRejectionModal(true), text: onboardingStep === "receiving_info" ? ReactiveCore.translations.invoicing_onboarding.reject_data : ReactiveCore.translations.invoicing_onboarding.reject_contract, permissions: (onboardingStep === 'signed_contract' || onboardingStep === 'receiving_info') },
    { icon: 'fa-repeat', action: handleGenerateContract, text: unsignedContractFile ? ReactiveCore.translations.invoicing_onboarding.recreate_contract : ReactiveCore.translations.invoicing_onboarding.create_contract, permissions: !contractGenerationStarted && settings.length > 0 },
    { icon: 'fa-circle-check', action: handleSubmitContract, text: onboardingStep === 'signing_contract' ? ReactiveCore.translations.invoicing_onboarding.resend_contract : ReactiveCore.translations.invoicing_onboarding.submit_contract, permissions: (['receiving_info', 'signing_contract'].includes(onboardingStep) && unsignedContractFile && !contractGenerationStarted) }
  ]

  const contractDropdownActions = [
    { icon: 'fa-ban', action: () => setShowRejectionModal(true), text: ReactiveCore.translations.invoicing_onboarding.reject_contract, permissions: onboardingStep === 'signed_contract' },
    { icon: 'fa-thumbs-up', action: handleAcceptContract, text: ReactiveCore.translations.invoicing_onboarding.approve_contract, permissions: (onboardingStep === 'signed_contract' && signedContractFiles.length > 0) }
  ]

  const authorizationDropdownActions = [
    { icon: 'fa-ban', action: () => setShowRejectionModal(true), text: ReactiveCore.translations.invoicing_onboarding.reject_authorization, permissions: onboardingStep === 'completed_authorization' },
    { icon: 'fa-envelope', action: () => setShowEmailToProviderAlert(true), text: ReactiveCore.translations.invoicing_onboarding.inform_provider, permissions: onboardingStep === 'completed_authorization' }
  ]

  const statementDropdownActions = [
    { icon: 'fa-circle-check', action: handleCompleteAuthorization, text: ReactiveCore.translations.invoicing_onboarding.complete_authorization, permissions: onboardingStep === 'completed_authorization' },
    { icon: 'fa-ban', action: () => setShowStatementRejectionModal(true), text: ReactiveCore.translations.invoicing_onboarding.reject_statement, permissions: onboardingStep === 'completed_statement' },
    { icon: 'fa-envelope', action: () => setShowEmailToProviderAlert(true), text: ReactiveCore.translations.invoicing_onboarding.inform_provider, permissions: onboardingStep === 'completed_statement' },
    { icon: 'fa-envelope', action: () => setShowNotifyCustomerAlert(true), text: ReactiveCore.translations.invoicing_onboarding.inform_customer, permissions: onboardingStep === 'completed_statement' || onboardingStep === 'completed' },
    { icon: 'fa-circle-check', action: handleSaveApiIntegrationKeys, text: ReactiveCore.translations.invoicing_onboarding.save, permissions: onboardingStep === 'completed_statement' || onboardingStep === 'completed' }
  ]

  const handleCloseStatementRejectionModal = () => {
    setShowStatementRejectionModal(false)
    resetStatementRejectionState()
  }

  const resetStatementRejectionState = () => {
    setCurrentRadioOption('default')
    setRejectionExplanation('')
    setStatementRejectionDates(initialStatementDateState)
  }

  const handleSetCurrentRadioOption = option => {
    setCurrentRadioOption(option.key)
  }

  return (
    <>
      { activities &&
        <Activities
          activities={ activities }
        />
      }

      { ((onboardingStep !== 'cancelled' && invoicingOnboarding) || onboardingStep == 'completed') ?
        <>
          { canManageInvoicingOnboarding &&
            <div className='card'>
              <div className='card-title flex-box content-space-between flex-wrap' style={{ gap: 20 }}>
                <h2>{ ReactiveCore.translations.invoicing_onboarding.invoicing_onboarding_header }</h2>
                <button
                  onClick={ () => setShowCancelAlert(true) }
                  className='btn reverted'
                >
                  { ReactiveCore.translations.invoicing_onboarding.cancel_process }
                </button>
              </div>
            </div>
          }

          <div className='card'>
            <div className='card-content'>
              <div className="card-body">
                <div className='flex-box content-space-between items-center flex-wrap' style={{ gap: 20 }}>
                  <div className='card-title'>
                    <div className='flex-box flex-column'>
                      <div className='flex-box items-center'>
                        { ['signing_contract', 'signed_contract', 'authorization', 'completed_authorization', 'statement', 'completed_statement', 'completed'].includes(onboardingStep) &&
                          <i className={'color-scheme m-r-10 fa-light fa-circle-check'} />
                        }
                        <div>{ ReactiveCore.translations.invoicing_onboarding.info_step_header }</div>
                      </div>
                      { ['signing_contract', 'signed_contract', 'authorization', 'completed_authorization', 'statement', 'completed_statement', 'completed'].includes(onboardingStep) &&
                        <div className='color-scheme' style={{ fontSize: 15 }}>
                          { ReactiveCore.translations.invoicing_onboarding.contract_creation_and_details_completed }
                        </div>
                      }
                    </div>
                  </div>
                  { canManageInvoicingOnboarding &&
                    <DropDownMenu
                      items={ infoDropdownActions }
                      title={ ReactiveCore.translations.invoicing_onboarding.actions }
                    />
                  }
                </div>

                <div>
                  { rejectedInfoReason &&
                    <div className='color-scheme'>
                      { `${ReactiveCore.translations.invoicing_onboarding.rejection_explanation}: ${rejectedInfoReason}` }
                    </div>
                  }

                  { idCopiesFiles.length > 0 &&
                    <div className='flex-box flex-column m-t-20' style={{ padding: 10, border: '2px dashed #dddddd', background: '#eeeeee', borderRadius: 8 }}>
                      { files.filter(file => contractFiles.includes(getFileUsage(file))).map((file, index) => (
                        <div className={ index !== 0 ? "m-t-10" : ""} key={ index }>
                          <div className='bold'>
                            { `${ReactiveCore.translations.invoicing_onboarding[getFileUsage(file)]}`}
                          </div>
                          <div>
                            { file.title }
                            <i className='m-l-10 fa-light fa-download pointer' onClick={ e => downloadFile(e, getFileUsage(file), file.title) }></i>
                          </div>
                        </div>
                      ))}

                      <div className='bold m-t-10'>
                        {`${ReactiveCore.translations.invoicing_onboarding[getFileUsage(idCopiesFiles[0])]} `}
                      </div>
                      { idCopiesFiles.map((idCopyFile, index) => (
                          <div className='flex-box' key={ index }>
                            <div>
                              { idCopyFile.title }
                            </div>
                            <div className='m-l-10'>
                              <i className='fa-light fa-download pointer' onClick={ e => downloadFile(e, getFileUsage(idCopyFile), idCopyFile.title) }></i>
                            </div>
                          </div>
                        ))
                      }

                      { unsignedContractFile && !contractGenerationStarted &&
                        <div className='m-t-10'>
                          <div className='bold'>
                            { ReactiveCore.translations.invoicing_onboarding['contract_to_be_signed'] }
                          </div>
                          <div>
                            { unsignedContractFile.title }
                            <i className='m-l-10 fa-light fa-download pointer' onClick={ e => downloadFile(e, 'unsigned_contract') }></i>
                          </div>
                        </div>
                      }
                    </div>
                  }

                  <div className='flex-box items-center content-space-between m-t-20'>
                    { files.length > 0 &&
                      <div className='flex-1'>
                        { ReactiveCore.translations.invoicing_onboarding.for_business_type }
                        <b>{` ${ businessType === 'individual' ? ReactiveCore.translations.invoicing_onboarding.individual_business_type : ReactiveCore.translations.invoicing_onboarding.non_individual_business_type }`} </b>
                        { ReactiveCore.translations.invoicing_onboarding.data_has_been_submitted }:
                      </div>
                    }
                  </div>

                  <div className='flex-box flex-wrap'>
                    { settings.filter(setting => !setting.key.startsWith('statement_')).map((setting, index) => (
                      <div key={ index } style={{ width: '25%', padding: '0px 10px' }}>
                        <InputField
                          label={ ReactiveCore.translations.invoicing_onboarding[setting.key] }
                          key={ setting.key }>
                          <input
                            type='text'
                            value={ setting.value }
                            onChange={ event => updateSetting(setting.key, event.target.value) }
                            className={`${canManageInvoicingOnboarding ? '' : 'disabled'} `}
                            disabled={ !canManageInvoicingOnboarding }
                          />
                        </InputField>
                        </div>
                      ))
                    }
                  </div>

                  { settings.length > 0 && canManageInvoicingOnboarding &&
                    <div className='flex-box items-center content-end m-t-20'>
                      <div className='flex-box content-end m-r-20'>
                        <button
                          onClick={ handleUpdateSettings }
                          className='btn reverted'
                        >
                          { ReactiveCore.translations.invoicing_onboarding.update_details }
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          { ['signing_contract', 'signed_contract', 'authorization', 'completed_authorization', 'statement', 'completed_statement', 'completed'].includes(onboardingStep) &&
            <div className='card'>
              <div className='card-content'>
                <div className="card-body">
                  <div className='flex-box content-space-between items-center flex-wrap' style={{ gap: 20 }}>
                    <div className='card-title'>
                      <div className='flex-box flex-column'>
                        <div className='flex-box items-center'>
                          { ['authorization', 'completed_authorization', 'statement', 'completed_statement', 'completed'].includes(onboardingStep) &&
                            <i className={'color-scheme m-r-10 fa-light fa-circle-check'} />
                          }
                          <div>{ ReactiveCore.translations.invoicing_onboarding.contract_step_header }</div>
                        </div>

                        { ['authorization', 'completed_authorization', 'statement', 'completed_statement', 'completed'].includes(onboardingStep) &&
                          <div className='color-scheme' style={{ fontSize: 15 }}>
                            { ReactiveCore.translations.invoicing_onboarding.contract_signing_completed }
                          </div>
                        }
                      </div>
                    </div>
                    { canManageInvoicingOnboarding &&
                      <DropDownMenu
                        items={ contractDropdownActions }
                        title={ ReactiveCore.translations.invoicing_onboarding.actions }
                      />
                    }
                  </div>

                  { onboardingStep === 'signing_contract' &&
                    <div className='flex-box content-center items-center m-t-15'>
                      { ReactiveCore.translations.invoicing_onboarding.contract_has_been_submitted }
                    </div>
                  }

                  { signedContractFiles.length > 0 &&
                    <div className='flex-box flex-column m-t-20' style={{ padding: 10, border: '2px dashed #dddddd', background: '#eeeeee', borderRadius: 8 }}>
                      <div>
                        <div className='bold'>{`${ReactiveCore.translations.invoicing_onboarding.signed_contract_label} `}</div>
                        <div className='flex-box flex-column'>
                          { signedContractFiles.map((signedContractFile, index) => (
                            <div className='flex-box items-center' key={ index }>
                              <div>
                                { signedContractFile.title }
                              </div>
                              <i className='m-l-10 fa-light fa-download pointer' onClick={ e => downloadFile(e, 'signed_contract', signedContractFile.title) }></i>
                            </div>
                          ))
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          { showAuthorization &&
            <div className='card'>
              <div className='card-content'>

                <div className='flex-box content-space-between items-center flex-wrap' style={{ gap: 20 }}>
                  <div className='card-title'>
                    <div className='flex-box flex-column'>
                      <div className='flex-box items-center'>
                        { ['statement', 'completed_statement', 'completed'].includes(onboardingStep) &&
                          <i className={`color-scheme m-r-10 fa-light fa-circle-check`} />
                        }
                        <div>{ ReactiveCore.translations.invoicing_onboarding.authorization_step_header }</div>
                      </div>

                      { (['statement', 'completed_statement', 'completed'].includes(onboardingStep) || informedProvider) &&
                        <div className='color-scheme' style={{ fontSize: 15 }}>
                          { ReactiveCore.translations.invoicing_onboarding.authorization_completed }
                        </div>
                      }
                    </div>
                  </div>
                  { canManageInvoicingOnboarding &&
                    <DropDownMenu
                      items={ authorizationDropdownActions }
                      title={ ReactiveCore.translations.invoicing_onboarding.actions }
                    />
                  }
                </div>

                { ['authorization', 'completed_authorization'].includes(onboardingStep) && informedProvider &&
                  <div style={{ fontSize: 15, fontWeight: 600 }}>
                    { ReactiveCore.translations.invoicing_onboarding.provider_informed }
                  </div>
                }

                { onboardingStep === 'authorization' &&
                  <div className='flex-box content-center items-center m-t-15'>
                    { ReactiveCore.translations.invoicing_onboarding.ongoing_authorization }
                  </div>
                }
              </div>
            </div>
          }

          { showStatement &&
            <div className='card'>
              <div className='card-content'>
                <div className="card-body">
                  <div className='flex-box content-space-between items-center flex-wrap' style={{ gap: 20 }}>
                    <div className='card-title'>
                      <div className='flex-box flex-column'>
                        <div className='flex-box items-center'>
                          { onboardingStep === 'completed' &&
                            <i className={'color-scheme m-r-10 fa-light fa-circle-check'} />
                          }
                          <div>{ ReactiveCore.translations.invoicing_onboarding.statement_step_header }</div>
                        </div>
                        { onboardingStep === 'completed' &&
                          <div className='color-scheme' style={{ fontSize: 15 }}>
                            { ReactiveCore.translations.invoicing_onboarding.account_enabled }
                          </div>
                        }
                      </div>
                    </div>
                    { canManageInvoicingOnboarding &&
                      <div style={{ zIndex: 10 }}>
                        <DropDownMenu
                          items={ statementDropdownActions }
                          title={ ReactiveCore.translations.invoicing_onboarding.actions }
                        />
                      </div>
                    }
                  </div>

                  { informedProvider && (currentStep !== 'completed_authorization') &&
                    <div style={{ fontSize: 15, fontWeight: 600 }}>
                      { ReactiveCore.translations.invoicing_onboarding.provider_informed }
                    </div>
                  }

                  { informedCustomer &&
                    <div style={{ fontSize: 15, fontWeight: 600 }}>
                      { ReactiveCore.translations.invoicing_onboarding.customer_informed }
                    </div>
                  }

                  { (onboardingStep === 'completed_authorization' || onboardingStep === 'statement') &&
                    <div className='flex-box flex-wrap m-t-5'>
                      <div style={{ paddingRight: '10px', width: '25%' }}>
                        <InputField
                          label={ `${ReactiveCore.translations.invoicing_onboarding.issue_validity_date} *` }>
                          <input
                            type='text'
                            placeholder={ ReactiveCore.translations.invoicing_onboarding.date_example }
                            value={ statementDates.issueValidity }
                            onChange={ event => setStatementDates(prevDates => ( { ...prevDates, issueValidity: event.target.value } )) }
                            disabled={ onboardingStep === 'statement' && !canManageInvoicingOnboarding }
                            className={`${canManageInvoicingOnboarding ? '' : 'disabled'} `}
                          />
                        </InputField>
                      </div>

                      <div style={{ paddingRight: '10px', width: '25%' }}>
                        <InputField
                          label={ `${ReactiveCore.translations.invoicing_onboarding.contract_conclusion_date} *` }>
                          <input
                            type='text'
                            placeholder={ ReactiveCore.translations.invoicing_onboarding.date_example }
                            value={ statementDates.contractConclusion }
                            onChange={ event => setStatementDates(prevDates => ( { ...prevDates, contractConclusion: event.target.value } )) }
                            disabled={ onboardingStep === 'statement' && !canManageInvoicingOnboarding }
                            className={`${canManageInvoicingOnboarding ? '' : 'disabled'} `}
                          />
                        </InputField>
                      </div>

                      <div style={{ paddingRight: '10px', width: '25%' }}>
                        <InputField
                          label={ `${ReactiveCore.translations.invoicing_onboarding.provider_agreement_no} *` }>
                          <input
                            type='text'
                            placeholder={ contractNumber }
                            value={ contractNumber }
                            onChange={ event => setContractNumber(event.target.value) }
                            disabled={ onboardingStep === 'statement' && !canManageInvoicingOnboarding }
                            className={`${canManageInvoicingOnboarding ? '' : 'disabled'} `}
                          />
                        </InputField>
                      </div>
                    </div>
                  }

                  { onboardingStep === 'statement' &&
                    <div className='flex-box content-center items-center m-t-15'>
                      { ReactiveCore.translations.invoicing_onboarding.ongoing_statement }
                    </div>
                  }

                  { statement &&
                    <div className='flex-box flex-column m-t-20' style={{ padding: 10, border: '2px dashed #dddddd', background: '#eeeeee', borderRadius: 8 }}>
                      <div className='bold'>
                        { ReactiveCore.translations.invoicing_onboarding.statement }
                      </div>
                      <div className='flex-box'>
                        { statement.title }
                        <div className='m-l-10'>
                          <i className='fa-light fa-download pointer' onClick={ e => downloadFile(e, getFileUsage(statement), statement.title) }></i>
                        </div>
                      </div>
                    </div>
                  }

                { (onboardingStep === 'completed_statement' || onboardingStep === 'completed') &&
                  <>
                    <InputField
                      label={ ReactiveCore.translations.invoicing_onboarding.api_key }>
                      <input
                        type='text'
                        value={ canManageInvoicingOnboarding ? apiKey : (apiKey.length > 0 ? apiKey.substring(0, 8) + '...' : '' ) }
                        onChange={ event => setApiKey(event.target.value) }
                        className={`${canManageInvoicingOnboarding ? '' : 'disabled'} `}
                        disabled={ !canManageInvoicingOnboarding }
                      />
                    </InputField>
                    
                    { series &&
                      <InputField
                        label={ ReactiveCore.translations.invoicing_onboarding.series }>
                        <input
                          type='text'
                          value={ series }
                          onChange={ event => setSeries(event.target.value) }
                          className={`${canManageInvoicingOnboarding ? '' : 'disabled'} `}
                          disabled={ !canManageInvoicingOnboarding }
                        />
                      </InputField>
                    }

                    { canManageInvoicingOnboarding &&
                      <CheckboxInput
                        label={ "Test mode" }
                        checked={ testMode }
                        setChecked={ checked => setTestMode(checked) }
                      />
                    }

                    { stores && stores.length > 0 &&
                      <div className='flex-box flex-column m-b-20'>
                        <div className='input-field'><label>{ ReactiveCore.translations.invoicing_onboarding.issuer_branches }</label></div>
                        <div className='flex-box flex-wrap' style={{ gap: 20 }}>
                          { stores.map( (store, index)=> {
                            return (
                              <div key={index} className='flex-box flex-1'>
                                <div className='m-r-10'>{ store.translations[0].title }</div>
                                <div className='bold'>{ store.invoice_issuer_branch }</div>
                              </div>
                            )
                          })}
                        </div>

                        <div className='input-field'><label>{ ReactiveCore.translations.invoicing_onboarding.series }</label></div>
                        <div className='flex-box flex-wrap' style={{ gap: 20 }}>
                          { stores.map( (store, index)=> {
                            return (
                              <div key={index} className='flex-box flex-1'>
                                <div className='m-r-10'>{ store.translations[0].title }</div>
                                <div className='bold'>{ store.invoice_series }</div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    }
                  </>
                }
                </div>
              </div>
            </div>
          }
        </>
        :
        <>
          { canSkipInvoicingOnboarding && canManageInvoicingOnboarding &&
            <div className='card'>
              <div className='card-title flex-box content-space-between'>
                <div>Invoicing Software Onboarding</div>
                <button
                  onClick={ () => setShowSkipOnboardingProcessAlert(true) }
                  className='btn'
                >
                  { ReactiveCore.translations.invoicing_onboarding.complete_process }
                </button>
              </div>
            </div>
          }

          <div className='card'>
            <div className='card-content'>
              <div className="card-body">
                <div className='flex-box content-center items-center'>
                  { ReactiveCore.translations.invoicing_onboarding.process_not_started }
                </div>
              </div>
            </div>
          </div>
        </>
      }

      <div style={{ marginBottom: 100 }} />

      <FlashMessage ref={ flashMessageRef }/>

      { loading && <GlobalLoader fullPage/> }

      { showRejectionModal &&
        <Modal
          closeModal={ () => setShowRejectionModal(false) }
          mode={ currentStep === 'receiving_info' ? 'large' : 'medium'}
          action={ handleRejectStep }
          disableAction={ currentStep === 'receiving_info' ? (rejectedFiles.length === 0 && rejectedSettings.length === 0) : false }
          visible
          showConfirmation
          confirmationText={ ReactiveCore.translations.invoicing_onboarding.confirm_rejection_explanation_text }
          actionText={ ReactiveCore.translations.invoicing_onboarding.accept }
        >
          <InputField label={ ReactiveCore.translations.invoicing_onboarding.rejection_explanation }>
            <textarea
              type='text'
              className={ 'custom-textarea' }
              value={ rejectionExplanation }
              onChange={ event => setRejectionExplanation(event.target.value) }
            />
          </InputField>

          { currentStep === 'receiving_info' &&
            <>
              <div className='m-b-10'>{ ReactiveCore.translations.invoicing_onboarding.rejected_details }</div>

              { settings.map((setting, index) => {
                  return(
                    <CheckboxInput
                      key={ index }
                      classes={ 'm-b-5' }
                      label={ ReactiveCore.translations.invoicing_onboarding[setting.key] }
                      checked={ rejectedSettings.includes(setting.key) }
                      setChecked={ checked => updateRejectedSettings(setting.key, checked) }
                    />
                  )}
                )
              }

              { files.filter(file => getFileUsage(file) !== 'unsigned_contract').map((file, index) => {
                  const fileUsage = getFileUsage(file)
                  return(
                    <CheckboxInput
                      key={ index }
                      classes={ 'm-b-5' }
                      label={ `${file.title} (${ReactiveCore.translations.invoicing_onboarding[fileUsage]})` }
                      checked={ rejectedFiles.includes(file.id) }
                      setChecked={ checked => updateRejectedFiles(file.id, checked) }
                    />
                  )}
                )
              }
            </>
          }
        </Modal>
      }

      { showStatementRejectionModal &&
        <Modal
          closeModal={ handleCloseStatementRejectionModal }
          mode='medium'
          action={ handleRejectStep }
          visible
          showConfirmation
          confirmationText={ currentRadioOption === 'default' ? ReactiveCore.translations.invoicing_onboarding.confirm_rejection_explanation_text : ReactiveCore.translations.invoicing_onboarding.confirm_date_rejection_explanation_text}
          actionText={ ReactiveCore.translations.invoicing_onboarding.accept }
        >
          <InputField label={ ReactiveCore.translations.invoicing_onboarding.statement_rejection_reason }>
            <RadioInput
              options={ radioOptions }
              currentOption={ currentRadioOption }
              setCurrentOption={ handleSetCurrentRadioOption }
            />
          </InputField>

          { currentRadioOption === 'default' &&
            <InputField label={ ReactiveCore.translations.invoicing_onboarding.rejection_explanation }>
              <textarea
                type='text'
                className={ 'custom-textarea' }
                value={ rejectionExplanation }
                onChange={ event => setRejectionExplanation(event.target.value) }
              />
            </InputField>
          }

          { currentRadioOption === 'wrong_dates' &&
            <div className='flex-box flex-wrap'>
              <div style={{ paddingRight: '10px', width: '25%' }}>
                <InputField
                  label={ `${ ReactiveCore.translations.invoicing_onboarding.issue_validity_date } *` }>
                  <input
                    type='text'
                    placeholder={ ReactiveCore.translations.invoicing_onboarding.date_example }
                    value={ statementRejectionDates.issueValidity }
                    onChange={ event => setStatementRejectionDates(prevDates => ({ ...prevDates, issueValidity: event.target.value })) }
                  />
                </InputField>
              </div>

              <div style={{ paddingRight: '10px', width: '25%' }}>
                <InputField
                  label={ `${ReactiveCore.translations.invoicing_onboarding.contract_conclusion_date} *` }>
                  <input
                    type='text'
                    placeholder={ ReactiveCore.translations.invoicing_onboarding.date_example }
                    value={ statementRejectionDates.contractConclusion }
                    onChange={ event => setStatementRejectionDates(prevDates => ( { ...prevDates, contractConclusion: event.target.value } )) }
                  />
                </InputField>
              </div>
            </div>
          }

          <div style={{ paddingRight: '10px', width: '25%' }}>
            <InputField
              label={ `${ReactiveCore.translations.invoicing_onboarding.provider_agreement_no} *` }>
              <input
                type='text'
                placeholder={ rejectedContractNumber }
                value={ rejectedContractNumber }
                onChange={ event => setRejectedContractNumber(event.target.value) }
              />
            </InputField>
          </div>

        </Modal>
      }

      { showCancelAlert &&
        <ModalAlert
          cancelText={ ReactiveCore.translations.invoicing_onboarding.cancel }
          acceptText={ ReactiveCore.translations.invoicing_onboarding.accept }
          alert={ ReactiveCore.translations.invoicing_onboarding.cancellation_alert }
          onSelect={ handleCancelOnboarding }
          onClose={ () => setShowCancelAlert(false) }
        />
      }

      { showNotifyCustomerAlert &&
        <ModalAlert
          cancelText={ ReactiveCore.translations.invoicing_onboarding.cancel }
          acceptText={ ReactiveCore.translations.invoicing_onboarding.accept }
          alert={ ReactiveCore.translations.invoicing_onboarding.notify_customer_alert }
          onSelect={ handleNotifyCustomerForApiKeys }
          onClose={ () => setShowNotifyCustomerAlert(false) }
        />
      }

      { showSkipOnboardingProcessAlert &&
        <ModalAlert
          cancelText={ ReactiveCore.translations.invoicing_onboarding.cancel }
          acceptText={ ReactiveCore.translations.invoicing_onboarding.accept }
          alert={ ReactiveCore.translations.invoicing_onboarding.skip_onboarding_process_alert }
          onSelect={ handleSkipOnboardingProcess }
          onClose={ () => setShowSkipOnboardingProcessAlert(false) }
        />
      }

      { showEmailToProviderAlert &&
        <ModalAlert
          cancelText={ ReactiveCore.translations.invoicing_onboarding.cancel }
          acceptText={ ReactiveCore.translations.invoicing_onboarding.accept }
          alert={ ReactiveCore.translations.invoicing_onboarding.email_to_provider_alert }
          onSelect={ handleSendMailToInvoicingSoftware }
          onClose={ () => setShowEmailToProviderAlert(false) }
        />
      }
    </>
  )
}
